import { X } from "lucide-react";
import { createPortal } from "react-dom";
import OtpLoginForm from "./OtpLoginForm";
import { useEffect, useRef, useState } from "react";

const LoginModal = ({ isOpen, onClose, onSuccess }) => {
  const [isMobile, setIsMobile] = useState(false);
  const dialogRef = useRef(null);

  // Detect screen size
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 1024);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  useEffect(() => {
    if (!isOpen) return;

    dialogRef.current?.focus();

    const onEsc = (e) => {
      if (e.key === "Escape") onClose();
    };

    document.addEventListener("keydown", onEsc);
    return () => document.removeEventListener("keydown", onEsc);
  }, [isOpen, onClose]);

  return createPortal(
    <div
      className={`fixed inset-0 z-50 transition-opacity ${
        isOpen ? "visible opacity-100" : "invisible opacity-0"
      } bg-black/60`}
      aria-hidden={!isOpen}
      onClick={onClose}
    >
      {/* Stop backdrop click from closing when clicking inside */}
      <div onClick={(e) => e.stopPropagation()}>
        {isMobile ? (
          /* Bottom Drawer */
          <div
            ref={dialogRef}
            role="dialog"
            aria-modal="true"
            tabIndex={-1}
            className="absolute bottom-0 left-0 right-0 bg-white rounded-t-2xl max-h-[90vh] animate-slideUp outline-none"
          >
            {/* Drag Handle */}
            <div className="flex justify-center py-2">
              <div className="w-12 h-1.5 bg-gray-300 rounded-full" />
            </div>

            {/* Close Button (Top Center) */}
            <button
              aria-label="Close login modal"
              onClick={onClose}
              className="absolute -top-10 left-1/2 -translate-x-1/2 bg-white shadow-md p-2 rounded-full"
            >
              <X size={18} />
            </button>

            <OtpLoginForm
              onSuccess={() => {
                onClose();
                onSuccess?.();
              }}
            />
          </div>
        ) : (
          /* Desktop Modal */
          <div className="flex items-center justify-center h-screen p-4">
            <div
              ref={dialogRef}
              role="dialog"
              aria-modal="true"
              tabIndex={-1}
              className="relative w-full max-w-md outline-none"
            >
              {/* Close Button (Top Center) */}
              <button
                aria-label="Close login modal"
                onClick={onClose}
                className="absolute -top-10 -right-10 -translate-x-1/2 bg-white/70 shadow-md p-2 rounded-full z-20"
              >
                <X size={18} />
              </button>

              {/* Scroll Container */}
              <div className="bg-white rounded-xl shadow-xl max-h-[90vh] overflow-y-auto">
                <OtpLoginForm
                  onSuccess={() => {
                    onClose();
                    onSuccess?.();
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default LoginModal;
